<template>
  <div class="warehouse-order-article -spacer -inline">
    <div class="warehouse-order-article_description ml-2">
      <div class="d-flex align-center">
        <slot/>
      </div>
    </div>

    <div class="warehouse-order-article_actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import ArticleCaption from "@/components/SmartLogistics/Article/ArticleCaption.vue";

export default {
  name: 'OrderArticleSpacer',
  components: {ArticleCaption},
}
</script>